(function () {
  var DEFAULT_WAITLIST_API = 'https://ang3lbyt.onrender.com/waitlist';
  var DEFAULT_BOOKING_API = 'https://ang3lbyt.onrender.com/booking';
  var EMAIL_PATTERN = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/;
  var SUBMIT_TIMEOUT_MS = 25000;
  var RETRY_DELAY_MS = 2000;
  var MAX_SUBMIT_ATTEMPTS = 3;

  var sections = document.querySelectorAll('[data-city-form], [data-waitlist-form]');
  if (!sections.length) return;

  sections.forEach(function (root) {
    var formType = root.getAttribute('data-form-type') || 'waitlist';
    var apiUrl =
      root.getAttribute('data-api-url') ||
      (formType === 'booking' ? DEFAULT_BOOKING_API : DEFAULT_WAITLIST_API);
    var storageKey =
      root.getAttribute('data-storage-key') ||
      (formType === 'booking' ? 'bookingSelectedCity' : 'waitlistSelectedCity');
    var titleTemplate =
      root.getAttribute('data-panel-title-template') ||
      root.getAttribute('data-waitlist-title-template') ||
      (formType === 'booking' ? '@ANG3LBYT [city] BOOKING <3' : '@ANG3LBYT [city] WAITLIST <3');
    var documentTitleTemplate =
      root.getAttribute('data-document-title-template') ||
      (formType === 'booking' ? '[city] - BOOKING' : '[city] - WAITLIST');
    var baseDocumentTitle = document.title;
    var successMessage =
      root.getAttribute('data-success-message') ||
      root.getAttribute('data-waitlist-success-message') ||
      'Thank you for submitting your information! I will contact you soon with updates or when your spot becomes available! <3';
    var submitErrorMessage =
      root.getAttribute('data-submit-error') ||
      root.getAttribute('data-waitlist-submit-error') ||
      'Something went wrong. Please try again.';
    var rateLimitErrorMessage =
      root.getAttribute('data-rate-limit-error') ||
      root.getAttribute('data-waitlist-rate-limit-error') ||
      'Too many submissions. Please try again later.';
    var duplicateErrorMessage =
      root.getAttribute('data-duplicate-error') ||
      'This contact has already been submitted for this city.';
    var ageErrorMessage =
      root.getAttribute('data-age-error') ||
      root.getAttribute('data-waitlist-age-error') ||
      'You must be 18 or older to continue.';
    var submittingLabel =
      root.getAttribute('data-submitting-label') ||
      root.getAttribute('data-waitlist-submitting-label') ||
      'Submitting...';

    var chooser = root.querySelector('[data-waitlist-chooser]');
    var panel = root.querySelector('[data-waitlist-panel]');
    var cityInput = root.querySelector('[data-waitlist-city-input]');
    var panelTitle = root.querySelector('[data-waitlist-panel-title]');
    var introTemplate = root.querySelector('[data-waitlist-intro-template]');
    var closeButtons = root.querySelectorAll('[data-waitlist-close]');
    var clearButton = root.querySelector('[data-waitlist-clear]');
    var triggers = root.querySelectorAll('[data-waitlist-city-trigger]');
    var form = root.querySelector('[data-city-form-element]');
    var contactInput = root.querySelector('[data-waitlist-contact-input]');
    var emailInput = root.querySelector('[data-waitlist-email-input]');
    var emailError = root.querySelector('[data-waitlist-email-error]');
    var nameInput = root.querySelector('[data-waitlist-name-input]');
    var ageYesInput = root.querySelector('[data-waitlist-age-yes]');
    var ageNoInput = root.querySelector('[data-waitlist-age-no]');
    var ageError = root.querySelector('[data-waitlist-age-error]');
    var budgetInput = root.querySelector('[data-waitlist-budget-input]');
    var notesInput = root.querySelector('[data-waitlist-notes-input]');
    var submitButton = root.querySelector('[data-waitlist-submit]');
    var formBody = root.querySelector('[data-waitlist-form-body]');
    var successStatus = root.querySelector('[data-waitlist-success]');
    var errorStatus = root.querySelector('[data-waitlist-error]');
    var errorMessage = root.querySelector('[data-waitlist-error-message]');
    var defaultSubmitLabel = submitButton ? submitButton.textContent.trim() : 'Submit';
    var isSubmitting = false;

    if (!chooser || !panel || !cityInput || !form) return;

    function rememberCity(city) {
      try {
        sessionStorage.setItem(storageKey, city);
      } catch (e) {}
    }

    function clearStoredCity() {
      try {
        sessionStorage.removeItem(storageKey);
      } catch (e) {}
    }

    function replaceCityToken(text, city) {
      return text.replace(/\[city\]/gi, city);
    }

    function updateDocumentTitle(city) {
      if (!city) {
        document.title = baseDocumentTitle;
        return;
      }
      document.title = replaceCityToken(documentTitleTemplate, city);
    }

    function updatePanelCopy(city) {
      if (panelTitle) {
        panelTitle.textContent = replaceCityToken(titleTemplate, city);
      }

      if (introTemplate) {
        var citySpan = introTemplate.querySelector('[data-waitlist-city-text]');
        if (citySpan) {
          citySpan.textContent = city;
        } else {
          introTemplate.innerHTML = replaceCityToken(introTemplate.innerHTML, city);
        }
      }

      updateDocumentTitle(city);
    }

    function extractEmail(value) {
      if (!value) return '';
      var match = value.match(EMAIL_PATTERN);
      return match ? match[0] : '';
    }

    function isCompleteEmail(value) {
      if (!value) return false;
      return EMAIL_PATTERN.test(value) && value.match(EMAIL_PATTERN)[0] === value;
    }

    function resolveEmail() {
      var typed = emailInput ? emailInput.value.trim() : '';
      if (typed) return typed;
      return extractEmail(contactInput ? contactInput.value.trim() : '');
    }

    function hideEmailError() {
      if (emailError) emailError.hidden = true;
      if (emailInput) emailInput.removeAttribute('aria-invalid');
      if (contactInput) contactInput.removeAttribute('aria-invalid');
    }

    function showEmailError() {
      if (emailError) emailError.hidden = false;
      if (emailInput) {
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.focus();
      }
    }

    function isAgeConfirmed() {
      return Boolean(ageYesInput && ageYesInput.checked);
    }

    function showAgeError() {
      if (ageError) {
        ageError.textContent = ageErrorMessage;
        ageError.hidden = false;
      }
      if (ageYesInput) ageYesInput.setAttribute('aria-invalid', 'true');
      if (ageNoInput) ageNoInput.setAttribute('aria-invalid', 'true');
    }

    function hideAgeError() {
      if (ageError) ageError.hidden = true;
      if (ageYesInput) ageYesInput.removeAttribute('aria-invalid');
      if (ageNoInput) ageNoInput.removeAttribute('aria-invalid');
    }

    function validateAge() {
      if (ageNoInput && ageNoInput.checked) {
        showAgeError();
        return false;
      }
      if (!isAgeConfirmed()) {
        showAgeError();
        return false;
      }
      hideAgeError();
      return true;
    }

    function focusAgeField() {
      if (ageNoInput && ageNoInput.checked) {
        ageNoInput.focus();
        return;
      }
      if (ageYesInput) ageYesInput.focus();
    }

    function hideStatusMessages() {
      if (successStatus) successStatus.hidden = true;
      if (errorStatus) errorStatus.hidden = true;
    }

    function showSuccess() {
      hideStatusMessages();
      if (formBody) formBody.hidden = true;
      if (successStatus) {
        successStatus.hidden = false;
        successStatus.focus();
      }
      root.classList.add('waitlist-page--success');
    }

    function showError(message) {
      hideStatusMessages();
      if (errorStatus) {
        errorStatus.hidden = false;
        if (errorMessage) {
          errorMessage.textContent = message || submitErrorMessage;
        }
        errorStatus.focus();
      }
    }

    function setSubmitting(next) {
      isSubmitting = next;
      if (!submitButton) return;
      submitButton.disabled = next;
      submitButton.textContent = next ? submittingLabel : defaultSubmitLabel;
    }

    if (ageYesInput) ageYesInput.addEventListener('change', hideAgeError);
    if (ageNoInput) ageNoInput.addEventListener('change', showAgeError);
    if (emailInput) emailInput.addEventListener('input', hideEmailError);
    if (contactInput) {
      contactInput.addEventListener('blur', function () {
        if (!emailInput || emailInput.value.trim()) return;
        var found = extractEmail(contactInput.value.trim());
        if (found) emailInput.value = found;
      });
    }

    function openPanel(city) {
      if (!city) return;
      hideStatusMessages();
      root.classList.remove('waitlist-page--success');
      if (formBody) formBody.hidden = false;
      cityInput.value = city;
      updatePanelCopy(city);
      rememberCity(city);
      panel.hidden = false;
      chooser.hidden = true;
      root.classList.add('waitlist-page--panel-open');
      if (nameInput) nameInput.focus();
    }

    function closePanel() {
      panel.hidden = true;
      chooser.hidden = false;
      root.classList.remove('waitlist-page--panel-open');
      root.classList.remove('waitlist-page--success');
      cityInput.value = '';
      clearStoredCity();
      updateDocumentTitle('');
      hideStatusMessages();
      if (formBody) formBody.hidden = false;
      closeButtons.forEach(function (button) {
        button.hidden = false;
      });
      form.reset();
      hideAgeError();
      hideEmailError();
      setSubmitting(false);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        openPanel(trigger.getAttribute('data-waitlist-city-trigger') || '');
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closePanel);
    });

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        form.reset();
        hideAgeError();
        hideStatusMessages();
        if (cityInput.value) updatePanelCopy(cityInput.value);
        hideEmailError();
        if (nameInput) nameInput.focus();
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (isSubmitting) return;

      hideStatusMessages();

      if (cityInput.value) rememberCity(cityInput.value);

      if (!validateAge()) {
        focusAgeField();
        return;
      }

      if (!contactInput) return;

      var typedEmail = emailInput ? emailInput.value.trim() : '';
      if (typedEmail && !isCompleteEmail(typedEmail)) {
        showEmailError();
        return;
      }

      var email = resolveEmail();
      if (email && !isCompleteEmail(email)) {
        email = '';
      }
      if (emailInput && !typedEmail && email) {
        emailInput.value = email;
      }
      hideEmailError();

      if (nameInput && !nameInput.value.trim()) {
        nameInput.focus();
        return;
      }
      if (!contactInput.value.trim()) {
        contactInput.focus();
        return;
      }
      if (budgetInput && !budgetInput.value.trim()) {
        budgetInput.focus();
        return;
      }

      var payload = {
        city: cityInput.value.trim(),
        name: nameInput ? nameInput.value.trim() : '',
        email: email,
        contact_info: contactInput.value.trim(),
        budget: budgetInput ? budgetInput.value.trim() : '',
        notes: notesInput ? notesInput.value.trim() : '',
        age_confirmed: isAgeConfirmed(),
        submission_type: formType,
      };

      setSubmitting(true);

      postSubmission(payload, 0)
        .then(function (result) {
          var response = result.response;
          if (response.status === 429) throw new Error('rate_limit');
          if (response.status === 409 && result.attempt > 0) {
            clearStoredCity();
            showSuccess();
            return;
          }
          if (response.status === 409) throw new Error('duplicate');
          if (response.status === 422) throw new Error('age_required');
          if (!response.ok) throw new Error('submit_failed');
          clearStoredCity();
          showSuccess();
        })
        .catch(function (error) {
          if (error && error.message === 'rate_limit') {
            showError(rateLimitErrorMessage);
            return;
          }
          if (error && error.message === 'duplicate') {
            showError(duplicateErrorMessage);
            return;
          }
          if (error && error.message === 'age_required') {
            showAgeError();
            focusAgeField();
            return;
          }
          showError(submitErrorMessage);
        })
        .finally(function () {
          setSubmitting(false);
        });
    });

    function wait(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    function shouldRetry(error, response, attempt) {
      if (attempt >= MAX_SUBMIT_ATTEMPTS - 1) return false;
      if (response && (response.status === 502 || response.status === 503)) return true;
      if (!response && error && (error.name === 'AbortError' || error.name === 'TypeError')) {
        return true;
      }
      return false;
    }

    function retryDelay(attempt) {
      return RETRY_DELAY_MS * (attempt + 1);
    }

    function postSubmission(payload, attempt) {
      var controller = new AbortController();
      var timer = setTimeout(function () {
        controller.abort();
      }, SUBMIT_TIMEOUT_MS);

      return fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
        signal: controller.signal,
      })
        .then(
          function (response) {
            clearTimeout(timer);
            if (shouldRetry(null, response, attempt)) {
              return wait(retryDelay(attempt)).then(function () {
                return postSubmission(payload, attempt + 1);
              });
            }
            return { response: response, attempt: attempt };
          },
          function (error) {
            clearTimeout(timer);
            if (shouldRetry(error, null, attempt)) {
              return wait(retryDelay(attempt)).then(function () {
                return postSubmission(payload, attempt + 1);
              });
            }
            throw error;
          }
        );
    }
  });
})();
